import React from 'react';
import type { ModuleIconName } from '../data/landing';
export function ModuleIcon({
  name
}: {
  name: ModuleIconName;
}) {
  return <svg viewBox="0 0 32 32" className="h-9 w-9" fill="none" stroke="#C9A96E" strokeWidth={1.1} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-35" data-mp="219q3qhw930yi">
      {name === 'wave' && <>
          <path d="M3 16c2.2-5.5 4.4-5.5 6.5 0s4.3 5.5 6.5 0 4.3-5.5 6.5 0 4.3 5.5 6.5 0" data-id="element-36" data-mp="2f9hd25btnt66" />
          <path d="M3 22c2.2-3 4.4-3 6.5 0s4.3 3 6.5 0 4.3-3 6.5 0 4.3 3 6.5 0" opacity={0.55} data-id="element-37" data-mp="2k7smiey7g1nv" />
        </>}
      {name === 'contour' && <>
          <path d="M5 17c-1-6 4-11 11-11s12 3 11 9-5 11-12 11S6 22 5 17Z" data-id="element-38" data-mp="2ozke8st3kdfl" />
          <path d="M9.5 16.5c-.5-3.8 2.6-6.8 6.8-6.8s7.6 2 7 5.7-3.2 6.8-7.4 6.8-6-2.3-6.4-5.7Z" data-id="element-39" data-mp="2sz2o8tjdr43n" />
          <path d="M13.5 16.2c-.2-1.8 1.2-3 3-3s3.2.9 2.9 2.6-1.4 2.9-3.2 2.9-2.5-1-2.7-2.5Z" data-id="element-40" data-mp="2y0s0udm93ptu" />
        </>}
      {name === 'concentric' && <>
          <circle cx="16" cy="16" r="12.5" data-id="element-41" data-mp="aqhs3mcv42us" />
          <circle cx="16" cy="16" r="8" data-id="element-42" data-mp="asaz52re0p3b" />
          <circle cx="16" cy="16" r="3.5" data-id="element-43" data-mp="5rmx7m1menub" />
          <circle cx="16" cy="16" r="0.6" fill="#C9A96E" data-id="element-44" data-mp="5qlovpbzofga" />
        </>}
      {name === 'steps' && <>
          <path d="M4 27h6v-6h6v-6h6V9h6" data-id="element-45" data-mp="1ql4zp64fc1u" />
          <path d="M4 27h24" opacity={0.55} data-id="element-46" data-mp="3swmcxoushpj9" />
        </>}
    </svg>;
}